import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { SupplierGroupsPage } from '../../features/suppliers/supplier-groups-page'

export const Route = createFileRoute('/_app/supplier-groups')({
  staticData: { crumb: 'supplierGroups' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'suppliers.read'),
  component: SupplierGroupsPage,
})
